import { cn } from '@/lib/utils';

interface SkeletonCardProps {
  className?: string;
  lines?: number;
  showAvatar?: boolean;
}

export function SkeletonCard({ className, lines = 3, showAvatar = false }: SkeletonCardProps) {
  return (
    <div className={cn('card-glass p-6 animate-pulse', className)}>
      <div className="flex items-start gap-4">
        {showAvatar && (
          <div className="w-12 h-12 rounded-full bg-muted shimmer" />
        )}
        <div className="flex-1 space-y-3">
          <div className="h-4 bg-muted rounded shimmer w-3/4" />
          {Array.from({ length: lines - 1 }).map((_, i) => (
            <div 
              key={i} 
              className="h-3 bg-muted rounded shimmer" 
              style={{ width: `${60 + Math.random() * 30}%` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export function SkeletonTable({ rows = 5 }: { rows?: number }) {
  return (
    <div className="card-luxury overflow-hidden animate-pulse">
      <div className="p-4 border-b border-border">
        <div className="flex gap-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-4 bg-muted rounded shimmer flex-1" />
          ))}
        </div>
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="p-4 border-b border-border last:border-0">
          <div className="flex gap-4">
            {[1, 2, 3, 4, 5].map((j) => (
              <div 
                key={j} 
                className="h-4 bg-muted/60 rounded shimmer flex-1"
                style={{ animationDelay: `${i * 50}ms` }}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonStats({ count = 5 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="stat-card animate-pulse" style={{ animationDelay: `${i * 50}ms` }}>
          <div className="flex items-center justify-between mb-3">
            <div className="w-10 h-10 rounded-lg bg-muted shimmer" />
          </div>
          <div className="h-8 bg-muted rounded shimmer w-16 mb-2" />
          <div className="h-3 bg-muted/60 rounded shimmer w-24" />
        </div>
      ))}
    </div>
  );
}
